import React from 'react';

import BlueprintVideoCard from './BlueprintVideoCard';
import SectionHeader from './SectionHeader';
import { Section, SectionItem } from './types';

interface BlueprintVideoSectionProps {
  section: Section;
  onPlayVideo?: (item: SectionItem) => void;
}

const BlueprintVideoSection = ({ section, onPlayVideo }: BlueprintVideoSectionProps) => {
  return (
    <article>
      <SectionHeader title={section.title} anchorId={section.anchorId} />
      <div className="mt-40 grid grid-cols-1 gap-y-40 sm:grid-cols-2 sm:gap-x-[52px] lg:grid-cols-3 lg:gap-x-24 lg:gap-y-64">
        {section.items.map((item) => (
          <BlueprintVideoCard key={item.id} item={item} onPlay={onPlayVideo} />
        ))}
      </div>
    </article>
  );
};

export default BlueprintVideoSection;
